// http-common.js
import axios from 'axios';
export default axios.create({
    baseURL: (process.env.REACT_APP_ENV_API_URL || 'http://localhost:8080') + '/api',
    headers: {
        'Content-type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
    },
});
